import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'move_resources',
    viewPath: props.viewPath,
  })
  return function onClick() {
    submit({ type: 'close' })
  }
}
